import { render, staticRenderFns } from "./lahi.pug?vue&type=template&id=06172d68&lang=pug&external"
import script from "./lahi.js?vue&type=script&lang=js&external"
export * from "./lahi.js?vue&type=script&lang=js&external"
import style0 from "./lahi-placeholder.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./lahi.scss?vue&type=style&index=1&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports